// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search_8h5zU","visuallyHidden":"search_visuallyHidden_1vW4A","input":"search_input_3xqt0"};